import { ContainerModule, WebuiIocKey } from '@ztechapps/webui.contract'
import { CreateAndBuild } from './create-and-build/CreateAndBuild'

export const workOrderContainer = new ContainerModule((bind) => {
  bind(WebuiIocKey.workOrder.createAndBuild).to(CreateAndBuild)
})
